
    var locales = require('../../../../../locale-loader/runtime.js');
    module.exports = locales.getLocale({"en":{"notFound":"Not found","loading":"Loading"},"ja":{"notFound":"見つかりません","loading":"ローディング中"},"ko":{"notFound":"찾을 수 없음","loading":"로드 중"},"ru":{"notFound":"Ничего не найдено","loading":"Загрузка"},"zh":{"notFound":"未找到","loading":"加载中"}});
  